// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

const transformResponse = ({ result, success, error }) => {
    const confirmed = (result || []).filter(x => x.status !== 'ReleaseConfirmed');
    return {
        error,
        payload: confirmed.length > 0 ? confirmed[0] : null,
        success,
    };
};

type CompleteEscrowDepositParams = {
    authToken: string,
    deployment: string,
    depositId: any,
};

export const completeEscrowDeposit = ({ authToken, deployment, depositId }: CompleteEscrowDepositParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'complete', authToken, deployment, path: '<ESCROW-API>' });
        request.send({ depositId });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type FetchEscrowAccountInfoParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

export const fetchEscrowAccountInfo = ({ authToken, bidderId, deployment }: FetchEscrowAccountInfoParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ apiPath: `deposit/${bidderId}`, authToken, deployment, path: '<ESCROW-API>' });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform: transformResponse,
            })
        );
    });

type ReleaseEscrowDepositParams = {
    authToken: string,
    deployment: string,
    depositId: any,
};

export const releaseEscrowDeposit = ({ authToken, deployment, depositId }: ReleaseEscrowDepositParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ apiPath: 'release', authToken, deployment, path: '<ESCROW-API>' });
        request.send({ depositId });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform: transformResponse,
            })
        );
    });
